// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"0f8b7281022bcf72f4be","339":"1a8b743a0d73f9d3e1ce"}[chunkId] + ".js";
};